import { get } from '../axios'

export function cmc_admin_category_list_get(map, option) {
  return get(
    `${process.env.VUE_APP_CMC_ADMIN}/cmc-admin/category/list`,
    map,
    option
  ).then(response => response)
}
